import React, { useState } from 'react'
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, TextField, Button, FormControl, Select, MenuItem } from '@material-ui/core'
import { Timestamp } from '@firebase/firestore';

import { getGeohashFromLatLng, addCustomLocation } from '../../api/index'

const AddCustomLocationModal = ({ open, setModalOpen, isLoading, setIsLoading, customLocationCoordinates, finishedAddingCustomLocation }) => {

    const [name, setName] = useState("")
    const [category, setCategory] = useState("Please Select One")
    const [email, setEmail] = useState("")
    const [phone, setPhone] = useState("")
    const [address, setAddress] = useState("")
    const [suite, setSuite] = useState("")
    const [city, setCity] = useState("")
    const [state, setState] = useState("")
    const [zipcode, setZipcode] = useState("")

    const handleName = (event) => setName(event.target.value)
    const handleEmail = (event) => setEmail(event.target.value)
    const handlePhone = (event) => setPhone(event.target.value)
    const handleAddress = (event) => setAddress(event.target.value)
    const handleSuite = (event) => setSuite(event.target.value)
    const handleCity = (event) => setCity(event.target.value)
    const handleState = (event) => setState(event.target.value)
    const handleZipcode = (event) => setZipcode(event.target.value)

    const [errorOpen, setErrorOpen] = useState(false)

    function handleClose() {
        setModalOpen(false)
    }

    function handleErrorClose() {
        setErrorOpen(false)
    }

    function checkCustomLocationData() {

        if(category === "Please Select One" || stringEmpty(name) || stringEmpty(address) || stringEmpty(city) || stringEmpty(state) || stringEmpty(zipcode)) {
            setErrorOpen(true)
            return;
        }

        const lat = customLocationCoordinates.lat
        const lng = customLocationCoordinates.lng
        const geohash = getGeohashFromLatLng(lat, lng)
        
        const customLocationData = {
            name: name,
            category1: category,
            email: email,
            phone: phone,
            address: address,
            suite: suite,
            city: city,
            state: state,
            zipcode: zipcode,
            geohash: geohash,
            lat: lat,
            lng: lng,
            // defaults that don't get changed
            'timestamp': Timestamp.now(),
            isUserCustomLocation: true,
            website: "",
            insuranceInfo: "",
            extraInfo: "",
        }

        console.log("DATA CHECK")
        console.log(customLocationData)

        setIsLoading(true)
        addCustomLocation(customLocationData, () => {
            finishedAddingCustomLocation()
        })
    }

    function stringEmpty(str) {
        return (!str || str.length === 0 );
    }

    return (
        <div>
            <Dialog open={open} onClose={handleClose}>
                <DialogTitle>Create a new resource</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Other people will be able to see this resource after you add it.
                    </DialogContentText>
                    <FormControl>
                        <Select value={category} onChange={(e) => setCategory(e.target.value)}>
                            <MenuItem value="Please Select One">Please select one</MenuItem>
                            <MenuItem value="Pharmacy">Pharmacy</MenuItem>
                            <MenuItem value="Substance Use Disorder Treatment">Substance Use Disorder Treatment</MenuItem>
                            <MenuItem value="Sharps Disposal">Sharps Disposal</MenuItem>
                            <MenuItem value="Health Clinic">Health Clinic</MenuItem>
                            <MenuItem value="HIV Services">HIV Services</MenuItem>
                            <MenuItem value="Syringe Exchange">Syringe Exchange</MenuItem>
                        </Select>
                    </FormControl>
                    <TextField
                        autoFocus
                        margin="dense"
                        id="name"
                        label="Location name"
                        fullWidth
                        required
                        variant="outlined"
                        onChange={handleName}
                        value={name}
                    />
                    <TextField
                        id="email"
                        label="Contact email (optional)"
                        value={email}
                        margin="dense"
                        fullWidth
                        variant="outlined"
                        onChange={handleEmail}
                    />
                    <TextField
                        id="phone"
                        label="Phone number (optional)"
                        value={phone}
                        margin="dense"
                        fullWidth
                        variant="outlined"
                        onChange={handlePhone}
                    />
                    <TextField
                        id="address"
                        label="Address"
                        value={address}
                        required
                        margin="dense"
                        fullWidth
                        variant="outlined"
                        onChange={handleAddress}
                    />
                    <TextField
                        id="suite"
                        label="Address 2 (optional)"
                        value={suite}
                        margin="dense"
                        fullWidth
                        variant="outlined"
                        onChange={handleSuite}
                    />
                    <TextField
                        id="city"
                        label="City"
                        value={city}
                        required
                        margin="dense"
                        fullWidth
                        variant="outlined"
                        onChange={handleCity}
                    />
                    <TextField
                        id="state"
                        label="State"
                        value={state}
                        required
                        margin="dense"
                        fullWidth
                        variant="outlined"
                        onChange={handleState}
                    />
                    <TextField
                        id="zipcode"
                        label="Zip Code"
                        value={zipcode}
                        required
                        margin="dense"
                        fullWidth
                        variant="outlined"
                        onChange={handleZipcode}
                    />
                    
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} disabled={isLoading}>Cancel</Button>
                    <Button onClick={checkCustomLocationData} disabled={isLoading}>Submit</Button>
                </DialogActions>
            </Dialog>
            <Dialog open={errorOpen} onClose={handleErrorClose}>
                <DialogTitle>Error</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Please make sure you have selected a category and all required fields are filled in!
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleErrorClose}>Ok</Button>
                </DialogActions>
            </Dialog>
        </div>
        
    )
}

export default AddCustomLocationModal